<template>

  <svg
    t="1639131986503"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4869"
    width="64"
    height="64"
  ><path d="M148.95240533 309.952512a36.32878933 36.32878933 0 0 1 52.21034667-9.08765867l272.54237867 204.95291734a63.635456 63.635456 0 0 0 76.58973866 0l272.52053334-204.95291734a36.306944 36.306944 0 0 1 52.21034666 9.08765867c12.582912 19.00544 10.76974933 44.19310933-4.36906666 61.16693333L575.504384 701.94517333a84.91281067 84.91281067 0 0 1-127.008768 0L153.36516267 371.14129067a50.331648 50.331648 0 0 1-4.41275734-61.16693334z" p-id="4870" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconArrowDown',
} as DefineComponent
</script>